import React from 'react'
import api from '@api'
import { IEmployeeLike } from '@permissions/types'
import { Button, Confirmation, Toaster } from '@ui'
import { pluralize } from '@utils'
import { ISelection } from '@hooks/useSelection'
import { Intent } from '@blueprintjs/core'
import { ApolloError } from 'apollo-boost'

interface Props {
  disabled: boolean
  selectedEmployees: IEmployeeLike[]
  selection: ISelection
  reload: () => void
}
export default function MultiDeleteButton({
  disabled,
  selectedEmployees,
  reload,
  selection,
}: Props) {
  return (
    <Confirmation
      disabled={disabled}
      text={`Delete selected employee${pluralize(selectedEmployees.length)}?`}
      onConfirm={() => {
        // TODO: need to add batchDeleteMethod to backend and remove cycle below
        Promise.all(selectedEmployees.map((e) => api.employee.remove(e.id)))
          .then(() => {
            selection.clear()
            reload()
            Toaster.success({
              message: `${selectedEmployees.length} ${pluralize(
                selectedEmployees.length,
                'Employee'
              )} deleted`,
            })
          })
          .catch((error: ApolloError) =>
            Toaster.fail({
              error,
            })
          )
      }}
    >
      <Button
        ghost
        data-button="delete_users"
        disabled={disabled}
        intent={Intent.DANGER}
        iconName="trash"
        text="Delete"
      />
    </Confirmation>
  )
}
